import { render, staticRenderFns } from "./BookingQuickLinks.vue?vue&type=template&id=dc7488ea&scoped=true&"
import script from "./BookingQuickLinks.vue?vue&type=script&lang=ts&"
export * from "./BookingQuickLinks.vue?vue&type=script&lang=ts&"
import style0 from "./BookingQuickLinks.vue?vue&type=style&index=0&id=dc7488ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc7488ea",
  null
  
)

export default component.exports